/*
  Variant-level per-market OOS + Klaviyo notify controller.

  Reads the per-variant state map rendered by snippets/buy-buttons.liquid and, on
  each variant change (Dawn's PUB_SUB_EVENTS.variantChange), toggles:
    - the "sold out" body class that hides quantity + subscription for OOS variants
      (the submit button itself is already flipped to "Sold out" by product-info.js),
    - the Klaviyo notify form's visibility.
  It also stamps Klaviyo form submissions with the current variant / market / page so
  each signup is attributable.
*/
(function () {
  var mapEl = document.querySelector('[data-variant-oos-map]');
  if (!mapEl) return;

  var map = {};
  try {
    map = JSON.parse(mapEl.textContent) || {};
  } catch (e) {
    map = {};
  }

  var sectionId = mapEl.getAttribute('data-section-id');
  var productTitle = mapEl.getAttribute('data-product-title') || '';
  var market = mapEl.getAttribute('data-market') || '';
  var productInfo = document.getElementById('MainProduct-' + sectionId);
  var notifyEl = document.querySelector('[data-variant-notify][data-section-id="' + sectionId + '"]');
  var current = null;

  function currentVariantId() {
    var input =
      document.querySelector('#product-form-' + sectionId + ' input[name="id"]') ||
      (productInfo && productInfo.querySelector('input[name="id"].product-variant-id')) ||
      document.querySelector('input.product-variant-id');
    return input && input.value ? String(input.value) : null;
  }

  function apply(vid) {
    if (!vid) vid = currentVariantId();
    if (!vid) return;
    current = vid;
    var state = map[vid] || {};
    var notifyActive = !!(state.oos && state.notify);

    if (productInfo) {
      // Hide qty + subscription for OOS variants (button label handled by product-info.js).
      productInfo.classList.toggle('pdp--variant-oos', !!state.oos);
      // When the notify form is the CTA, hide the Sold Out button too.
      productInfo.classList.toggle('pdp--variant-notify', notifyActive);
    }

    // Show the notify form only when this variant is OOS AND flagged for notify.
    if (notifyEl) {
      notifyEl.hidden = !notifyActive;
      notifyEl.setAttribute('data-variant-id', vid);
      notifyEl.setAttribute('data-variant-title', state.title || '');
    }

    // Suppress the sticky ATC bar for notify variants — the form is the CTA.
    var sticky = document.getElementById('StickyAtc-' + sectionId);
    if (sticky) sticky.hidden = notifyActive;
  }

  apply(currentVariantId());

  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined' &&
    PUB_SUB_EVENTS.variantChange
  ) {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var v = event && event.data && event.data.variant;
      apply(v ? String(v.id) : null);
    });
  }

  // The Klaviyo form id for the notify form (from its klaviyo-form-XXXX class),
  // so we only tag submissions of OUR form and not other Klaviyo forms.
  function notifyFormId() {
    if (!notifyEl) return null;
    var div = notifyEl.querySelector('[class*="klaviyo-form-"]');
    var m = div && (div.className || '').match(/klaviyo-form-([A-Za-z0-9]+)/);
    return m ? m[1] : null;
  }

  function tagSubmission() {
    try {
      var vid = notifyEl ? notifyEl.getAttribute('data-variant-id') : current;
      if (!vid) return;
      var state = map[vid] || {};
      if (!(window.klaviyo && typeof window.klaviyo.push === 'function')) return;
      // Event (for the back-in-stock flow / segments), with per-signup context.
      window.klaviyo.push([
        'track',
        'Back in Stock Requested',
        {
          ProductTitle: productTitle,
          VariantID: vid,
          VariantTitle: state.title || '',
          Market: market,
          SourceURL: window.location.href,
        },
      ]);
      // Profile custom properties (visible on the Klaviyo profile).
      window.klaviyo.push([
        'identify',
        {
          'Last OOS Product': productTitle,
          'Last OOS Variant': state.title || '',
          'Last OOS Variant ID': vid,
          'Last OOS Market': market,
          'Last OOS URL': window.location.href,
        },
      ]);
    } catch (e) {}
  }

  // Klaviyo onsite forms dispatch a single `klaviyoForms` event on window; the
  // submit is e.detail.type === 'submit'. Only tag our notify form's submit.
  window.addEventListener('klaviyoForms', function (e) {
    if (!e || !e.detail || e.detail.type !== 'submit') return;
    var fid = notifyFormId();
    if (fid && e.detail.formId && String(e.detail.formId) !== String(fid)) return;
    tagSubmission();
  });
})();
